import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';
import isMobile from 'ismobilejs';

import {t} from 'l10n'

import 'sass/profile/postWallProfile.scss';

import paths from 'paths';

import WallMaterialList from 'components/list/WallMaterialList';

class ProfileWallPostsBlock extends Component
{
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render()
    {
        let {wallMaterials, sectionNumber, match} = this.props,
            {list, totalCount} = wallMaterials;

        return (
            <aside className={'post-wall-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <div className="content">
                    <div className="heading">
                        <h2>{t('Posts on the Wall')} <em>{totalCount}</em></h2>
                        {(list.length && !isMobile.any) ? <Link to={paths.profileWallMaterials.toPath({nick: match.params.nick})} className="list-items">{t('See all posts on the Wall')}</Link> : null}
                    </div>
                    <WallMaterialList wallMaterials={list} responsiveGrid="single-row" showDate showStats altThumbnail/>
                    {(list.length && isMobile.any ) ? <Link className="get-all-wall" to={paths.profileWallMaterials.toPath({nick: match.params.nick})}>{t('See all posts on the Wall')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default ProfileWallPostsBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileWallPostsBlock.js